import { useEffect, useState } from "react";
import axios from "axios";
import { API, getSessionId } from "./useVisitorSession";

const HEARTBEAT_INTERVAL_MS = 20000;

// Sends a heartbeat every 20s (and when the tab becomes visible) and returns the online count.
export function useHeartbeat() {
  const [online, setOnline] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const sendHeartbeat = async () => {
      try {
        const res = await axios.post(`${API}/visits/heartbeat`, { session_id: getSessionId() });
        if (!cancelled && typeof res.data?.online === "number") setOnline(res.data.online);
      } catch (e) {
        console.warn("[VisitorCounter] heartbeat falhou:", e?.message);
      }
    };

    const onVisibility = () => {
      if (document.visibilityState === "visible") sendHeartbeat();
    };

    sendHeartbeat();
    const timer = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      cancelled = true;
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);

  return online;
}
